import { render, staticRenderFns } from "./ImportInvoiceForm.vue?vue&type=template&id=3b151d62&scoped=true&"
import script from "./ImportInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./ImportInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b151d62",
  null
  
)

export default component.exports